<wl-invoice-summary [invoice]="invoice"></wl-invoice-summary>
<div class="details-form-row mct-flex mct-row mct-wrap mct-justify-around mct-items-stretch">
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="card-field-label">{{ 'invoices.invoice-builder.details-tab.communicate-with-profile' | translate | ucfirst }}</div>
    <p-select
      #communicateWithProfileSelector
      [style]="{ width: '100%', height: '36px' }"
      [options]="relatedProfiles"
      placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
      [(ngModel)]="selectedCommProfileId"
      (onChange)="selectedCommProfileChanged()"
    ></p-select>
  </div>
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="card-field-label">
      {{ 'invoices.invoice-builder.details-tab.attention-to' | translate | ucfirst }}
    </div>
    <input type="text" class="form-control" [(ngModel)]="invoice.InvoiceHeader.Attention" />
  </div>
</div>
<div class="details-form-row mct-flex mct-row mct-wrap mct-justify-around mct-items-stretch" style="margin-bottom: 54px">
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="card-field-label">
      {{ 'invoices.invoice-builder.details-tab.bill-to' | translate | ucfirst }}
    </div>
    <div class="mb-6">
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.BillToName" class="form-control" />
    </div>
    <div class="mb-6">
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.BillToAddress1" class="form-control" />
    </div>
    <div class="mb-6">
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.BillToAddress2" class="form-control" />
    </div>
    <div class="mct-flex mct-row mct-wrap mct-justify-between mct-items-stretch">
      <input
        type="text"
        [(ngModel)]="invoice.InvoiceHeader.BillToCity"
        class="form-control mb-6 inv-details-208px-gt-sm mct-basis-100-lt-sm"
      />
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.BillToState" class="form-control inv-details-40px-gt-sm mct-basis-30-lt-sm" />
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.BillToZip" class="form-control inv-details-62px-gt-sm mct-basis-30-lt-sm" />
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.BillToZipExt" class="form-control inv-details-60px-gt-sm mct-basis-30-lt-sm" />
    </div>
  </div>
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="card-field-label">
      {{ 'invoices.invoice-builder.details-tab.ship-to' | translate | ucfirst }}
    </div>
    <div class="mb-6">
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.ShipToName" class="form-control" />
    </div>
    <div class="mb-6">
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.ShipToAddress1" class="form-control" />
    </div>
    <div class="mb-6">
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.ShipToAddress2" class="form-control" />
    </div>
    <div class="mct-flex mct-row mct-wrap mct-justify-between mct-items-stretch">
      <input
        type="text"
        [(ngModel)]="invoice.InvoiceHeader.ShipToCity"
        class="form-control mb-6 inv-details-208px-gt-sm mct-basis-100-lt-sm"
      />
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.ShipToState" class="form-control inv-details-40px-gt-sm mct-basis-30-lt-sm" />
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.ShipToZip" class="form-control inv-details-62px-gt-sm mct-basis-30-lt-sm" />
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.ShipToZipExt" class="form-control inv-details-60px-gt-sm mct-basis-30-lt-sm" />
    </div>
  </div>
</div>
<div class="details-form-row mb-27 mct-flex mct-row mct-wrap mct-justify-around mct-items-stretch">
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="card-field-label">
      {{ 'invoices.invoice-builder.details-tab.invoice-memo' | translate | ucfirst }}
    </div>
    <div>
      <textarea [(ngModel)]="invoice.InvoiceHeader.Memo" class="form-control multiline"></textarea>
    </div>
  </div>
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="card-field-label">
      {{ 'invoices.invoice-builder.details-tab.customer-comments' | translate | ucfirst }}
    </div>
    <div>
      <textarea [(ngModel)]="invoice.InvoiceHeader.CustComments" class="form-control multiline"></textarea>
    </div>
  </div>
</div>
<div class="details-form-row mb-27 mct-flex mct-row mct-wrap mct-justify-around mct-items-stretch">
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="card-field-label">
      {{ 'invoices.invoice-builder.details-tab.terms' | translate | ucfirst }}
    </div>
    <div class="atlas-autocomplete">
      <p-autocomplete
        class="mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm"
        [(ngModel)]="invoice.InvoiceHeader.Terms"
        [suggestions]="filteredTerms"
        (completeMethod)="filterTerms($event)"
        [dropdown]="true"
      ></p-autocomplete>
    </div>
  </div>
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="card-field-label">
      {{ 'invoices.invoice-builder.details-tab.rep' | translate | ucfirst }}
    </div>
    <div>
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.Rep" class="form-control" />
    </div>
  </div>
</div>
<div class="details-form-row mb-27 mct-flex mct-row mct-wrap mct-justify-around mct-items-stretch">
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="card-field-label">
      {{ 'invoices.invoice-builder.details-tab.po-num' | translate | uppercase }}
    </div>
    <div>
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.Po" class="form-control" />
    </div>
  </div>
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="card-field-label">
      {{ 'invoices.invoice-builder.details-tab.ship-via' | translate | ucfirst }}
    </div>
    <div>
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.ShipVia" class="form-control" />
    </div>
  </div>
</div>
<div class="details-form-row mb-27 mct-flex mct-row mct-wrap mct-justify-around mct-items-stretch">
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="card-field-label">
      {{ 'invoices.invoice-builder.details-tab.ref-no' | translate | ucfirst }}
    </div>
    <div>
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.ReferenceNum" class="form-control" />
    </div>
  </div>
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="card-field-label">
      {{ 'invoices.invoice-builder.details-tab.batch-number' | translate | ucfirst }}
    </div>
    <div>
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.Batch_Creation" [disabled]="true" class="form-control" />
    </div>
  </div>
</div>
<div class="details-form-row mb-27 mct-flex mct-row mct-wrap mct-justify-around mct-items-stretch">
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="card-field-label">
      {{ 'invoices.invoice-builder.details-tab.collection-rep' | translate | ucfirst }}
    </div>
    <div>
      <p-select
        appendTo="body"
        [(ngModel)]="invoice.InvoiceHeader.CollectionRep"
        placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
        [(options)]="activeUsers"
        [style]="{ width: '100%' }"
      ></p-select>
    </div>
  </div>
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="card-field-label">
      {{ 'invoices.invoice-builder.details-tab.tracking-number' | translate | ucfirst }}
    </div>
    <div>
      <input type="text" [(ngModel)]="invoice.InvoiceHeader.TrackingNumber" class="form-control" />
    </div>
  </div>
</div>
<div class="details-form-row mb-27 mct-flex mct-row mct-wrap mct-justify-around mct-items-stretch">
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="light-text">
      {{ 'invoices.invoice-builder.details-tab.disable-online-payment' | translate | ucfirst }}
    </div>
    <div>
      <p-checkbox [binary]="true" [(ngModel)]="invoice.InvoiceHeader.DisableOnlinePayment"></p-checkbox>
    </div>
  </div>
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm"></div>
</div>
<div class="details-form-row mb-27 mct-flex mct-row mct-wrap mct-justify-around mct-items-stretch">
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="light-text">
      {{ 'invoices.invoice-builder.details-tab.invoice-sent' | translate | ucfirst }}
    </div>
    <div>
      <p-checkbox [binary]="true" name="invoiceSent" [(ngModel)]="invoice.InvoiceHeader.InvoiceSent"></p-checkbox>
    </div>
  </div>
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm"></div>
</div>
<div class="details-form-row mb-27 mct-flex mct-row mct-wrap mct-justify-around mct-items-stretch">
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="light-text">
      {{ 'invoices.invoice-builder.details-tab.sent-by' | translate | ucfirst }}
    </div>
    <div>
      <input type="text" name="sentBy" [(ngModel)]="invoice.InvoiceHeader.SentBy" class="form-control" />
    </div>
  </div>
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm"></div>
</div>
<div class="details-form-row mb-27 mct-flex mct-row mct-wrap mct-justify-around mct-items-stretch">
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm">
    <div class="light-text">
      {{ 'invoices.invoice-builder.details-tab.sent-date' | translate | ucfirst }}
    </div>
    <div>
      <wl-date-selector ngDefaultControl name="dateSent" [(ngModel)]="invoice.InvoiceHeader.DateSent"></wl-date-selector>
    </div>
  </div>
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm"></div>
</div>
<div class="details-form-row mb-27 mct-flex mct-row mct-wrap mct-justify-around mct-items-stretch">
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm" *ngIf="!hideinvoiceType">
    <div class="card-field-label">
      {{ 'invoices.invoice-builder.details-tab.invoice-types.invoice-type' | translate | ucfirst }}
    </div>
    <div>
      <p-select
        [options]="invoiceTypes"
        [(ngModel)]="invoice.InvoiceHeader.InvoiceType"
        placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
        [style]="{ width: '100%' }"
        showClear
      ></p-select>
    </div>
  </div>
  <div class="mct-flex mct-col mct-flex-0-0-390px-gt-sm mct-basis-100-lt-sm"></div>
</div>
